if (!customElements.get("product-gallery")) {
  class a extends HTMLElement {
    constructor() {
      (super(),
        (this.media = window.matchMedia("(min-width: 992px)")),
        this.media.addEventListener("change", () => this.onResize()),
        (this.swiper = void 0),
        this.listen(),
        this.onResize(),
        (this._variantChangeHandler = (e) => {
          (this.classList.add("loading"),
            fetch(
              `/products/${e.detail.product}?variant=${e.detail.variant}&view=gallery`,
            )
              .then((e) => e.text())
              .then((e) => {
                e = new DOMParser().parseFromString(e, "text/html");
                e.querySelector("product-gallery") &&
                  ((this.querySelector(".swiper-container").innerHTML =
                    e.querySelector(
                      "product-gallery .swiper-container",
                    ).innerHTML),
                  this.swiper && this.swiper.destroy(!0, !0),
                  (this.swiper = void 0),
                  this.listen(),
                  this.onResize(),
                  Promise.all(
                    Array.from(
                      this.querySelectorAll(".swiper-container img"),
                    ).map((img) =>
                      img.complete
                        ? Promise.resolve()
                        : new Promise((resolve) => {
                            img.addEventListener("load", resolve, {
                              once: true,
                            });
                            img.addEventListener("error", resolve, {
                              once: true,
                            });
                          }),
                    ),
                  ).then(() => {
                    this.swiper && this.swiper.update();
                  }),
                  setTimeout(() => {
                    (this.classList.remove("loading"),
                      window.dispatchEvent(new Event("resize")),
                      this.swiper && this.swiper.update());
                  }, 1e3));
              })
              .catch((e) => {
                setTimeout(() => {
                  this.classList.remove("loading");
                }, 1e3);
              }));
        }),
        window.addEventListener("variantChange", this._variantChangeHandler));
    }
    disconnectedCallback() {
      if (this._variantChangeHandler) {
        window.removeEventListener("variantChange", this._variantChangeHandler);
      }
      if (this._videoObserver) {
        this._videoObserver.disconnect();
      }
    }
    hydrateVideo(e, t = false) {
      if (!e || e.dataset.videoLoaded === "true") return;
      e.querySelectorAll("source[data-src]").forEach((e) => {
        e.src = e.dataset.src;
        e.removeAttribute("data-src");
      });
      e.dataset.videoLoaded = "true";
      e.load();
      if (t || e.hasAttribute("autoplay")) {
        e.play().catch(() => {});
      }
    }
    observeVideos() {
      if (this._videoObserver) {
        this._videoObserver.disconnect();
      }
      const e = this.querySelectorAll("video[data-lazy-video]");
      if (!e.length) return;
      if (!("IntersectionObserver" in window)) {
        e.forEach((e) => this.hydrateVideo(e));
        return;
      }
      this._videoObserver = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            if (!e.isIntersecting) return;
            this.hydrateVideo(e.target);
            this._videoObserver.unobserve(e.target);
          });
        },
        { rootMargin: "400px 0px" },
      );
      e.forEach((e) => this._videoObserver.observe(e));
    }
    listen() {
      (this.dataset.paginationEnable !== "false" &&
        this.querySelectorAll(".product__gallery-button button").forEach(
          (e) => {
            (12 < this.querySelectorAll(".swiper-slide").length &&
              (e.parentElement.style.display = "block"),
              e.addEventListener("click", () => {
                (this.querySelectorAll(".swiper-slide").forEach(
                  (e) => (e.style.display = "block"),
                ),
                  (e.parentElement.style.display = "none"),
                  setTimeout(() => {
                    window.dispatchEvent(new Event("resize"));
                  }));
              }));
          },
        ),
        // this.querySelectorAll("video").forEach((e) => {
        //   (e.addEventListener("mouseenter", () => {
        //     e.play();
        //   }),
        //     e.addEventListener("mouseleave", () => {
        //       e.pause();
        //     }));
        // }),
        setTimeout(() => {
          this.classList.remove("loading");
        }, 500));
      this.observeVideos();
    }
    /**
     * Dodatki galerii z projektu po audycie: licznik klatek, strzalka, kropki
     * i pas miniatur. Wszystko jest opcjonalne - gdy szablon nie wlaczyl
     * ustawienia, tych elementow nie ma w dokumencie i metoda nic nie robi.
     *
     * Kropki i miniatury buduje skrypt z listy slajdow (a nie Liquid), zeby nie
     * powtarzac filtrowania zdjec po wariancie i zeby po podmianie galerii
     * wszystko odswiezylo sie samo.
     */
    buildExtras() {
      const dots = this.querySelector("[data-gallery-dots]");
      const thumbs = this.querySelector("[data-gallery-thumbs]");
      const next = this.querySelector("[data-gallery-next]");
      const total = this.querySelector("[data-gallery-total]");
      if (!dots && !thumbs && !next) return;

      const slides = Array.from(
        this.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)"),
      );
      if (total) total.textContent = slides.length;

      if (dots) {
        dots.innerHTML = "";
        slides.forEach((_, i) => {
          const d = document.createElement("span");
          d.className =
            "product__gallery-dot" + (i === 0 ? " is-active" : "");
          dots.appendChild(d);
        });
      }

      if (thumbs) {
        // Pas miesci dokladnie tyle miniatur, ile szerokosc okna - reszta nie
        // jedzie w bok, tylko chowa sie pod licznikiem "+X" na ostatniej z nich.
        // Przewijany pas na telefonie ginal: nic nie zapowiadalo, ze da sie go
        // przesunac, wiec kupujacy widzial piec zdjec z pietnastu.
        const LIMIT = 5;
        thumbs.innerHTML = "";
        let widocznych = 0;
        let ostatnia = null;
        let pierwszyUkryty = null;
        slides.forEach((slide, i) => {
          const src = slide.querySelector("img");
          if (!src) return;
          const b = document.createElement("button");
          b.type = "button";
          b.className =
            "product__gallery-thumb" + (i === 0 ? " is-active" : "");
          b.dataset.index = String(i);
          b.setAttribute("aria-label", `${i + 1}`);
          const img = document.createElement("img");
          img.src = src.currentSrc || src.src;
          img.alt = "";
          img.loading = "lazy";
          b.appendChild(img);
          b.addEventListener("click", () => {
            // Licznik "+X" prowadzi do pelnej galerii, a nie do piatego zdjecia -
            // kupujacy klika go po to, zeby zobaczyc RESZTE. Otwieramy wiec okno
            // galerii na pierwszym ukrytym kadrze.
            if (b.classList.contains("product__gallery-thumb--more")) {
              const okno = document.querySelector("product-modal-gallery");
              if (okno && typeof okno.open === "function") {
                okno.open(Number(b.dataset.moreIndex || 0));
                return;
              }
            }
            if (!this.swiper) return;
            this.swiper.slideToLoop
              ? this.swiper.slideToLoop(i)
              : this.swiper.slideTo(i);
          });
          if (widocznych >= LIMIT) {
            b.hidden = true;
            if (pierwszyUkryty === null) pierwszyUkryty = i;
          }
          else {
            widocznych += 1;
            ostatnia = b;
          }
          thumbs.appendChild(b);
        });

        const ukryte = thumbs.querySelectorAll(".product__gallery-thumb[hidden]").length;
        if (ostatnia && ukryte > 0) {
          ostatnia.classList.add("product__gallery-thumb--more");
          ostatnia.dataset.more = "+" + ukryte;
          ostatnia.dataset.moreIndex = String(pierwszyUkryty ?? 0);
          ostatnia.setAttribute(
            "aria-label",
            `${widocznych}, pozostalo zdjec: ${ukryte}`,
          );
        }
      }

      if (next && !next.dataset.bound) {
        next.dataset.bound = "1";
        next.addEventListener("click", () => {
          this.swiper && this.swiper.slideNext();
        });
      }

      const prev = this.querySelector("[data-gallery-prev]");
      if (prev && !prev.dataset.bound) {
        prev.dataset.bound = "1";
        prev.addEventListener("click", () => {
          this.swiper && this.swiper.slidePrev();
        });
      }

      this.syncExtras(0);
    }

    syncExtras(index) {
      const cur = this.querySelector("[data-gallery-current]");
      if (cur) cur.textContent = index + 1;
      // strzalka wstecz pokazuje sie dopiero od drugiego slajdu
      const prev = this.querySelector("[data-gallery-prev]");
      if (prev) prev.classList.toggle("is-visible", index > 0);
      this.querySelectorAll(".product__gallery-dot").forEach((d, i) =>
        d.classList.toggle("is-active", i === index),
      );
      const thumbs = this.querySelectorAll(".product__gallery-thumb");
      thumbs.forEach((t, i) => t.classList.toggle("is-active", i === index));
      const active = thumbs[index];
      if (active && active.parentElement) {
        const p = active.parentElement;
        const off =
          active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left: Math.max(0, off), behavior: "smooth" });
      }
    }

    onResize() {
      this.media.matches
        ? void 0 !== this.swiper &&
          (this.swiper.destroy(), (this.swiper = void 0))
        : void 0 === this.swiper &&
          (this.swiper = new Swiper(this.querySelector(".swiper-container"), {
            // Przewijanie touchpadem: dwa palce w poziomie ruszaja karuzela.
            // forceToAxis pilnuje, zeby ruch w pionie nadal przewijal strone,
            // releaseOnEdges oddaje gest stronie na koncu karuzeli.
            mousewheel: { enabled: true, forceToAxis: true, releaseOnEdges: true, thresholdDelta: 8 },
            loop: !0,
            grabCursor: !1,
            speed: 500,
            spaceBetween: 0,
            slidesPerView: "auto",
            watchSlidesProgress: !0,
            scrollbar: {
              el: this.querySelector(".swiper-scrollbar"),
              enabled: !0,
            },
            breakpoints: { 768: { slidesPerView: "auto", spaceBetween: 16 } },
            on: {
              slideChangeTransitionEnd: function () {
                this.scrollbar && this.scrollbar.updateSize();
              },
              slideChange: (s) => this.syncExtras(s.realIndex || 0),
              init: () => this.buildExtras(),
            },
          }));
    }
  }
  customElements.define("product-gallery", a);
}
